module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightning-fill-cda871ee.svg";